import { type Chat } from '@pubnub/chat';
import { useEffect } from 'react';
import { useMessagesStore } from '@avanta/shared/stores/chat/messages';

interface UseReadReceiptsParams {
  activeChannelId: string | null;
  chat: Chat | null;
}

export const useReadReceipts = ({ activeChannelId, chat }: UseReadReceiptsParams): void => {
  useEffect(() => {
    if (!activeChannelId || !chat) return;

    let cancelled = false;
    let unsubscribe: (() => void) | undefined;

    const stream = async (): Promise<void> => {
      const channel = await chat.getChannel(activeChannelId);
      if (!channel || cancelled) return;

      unsubscribe = await channel.streamReadReceipts(receipts => {
        useMessagesStore.getState().setReadReceipts(activeChannelId, receipts);
      });
    };

    stream();

    return (): void => {
      cancelled = true;
      unsubscribe?.();
    };
  }, [activeChannelId, chat]);
};
